/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-11-04 11:19:00
 * @LastEditors: Jack Deng
 * @LastEditTime: 2023-03-13 15:03:39
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/ReadyToShip/index.tsx
 */
import { ModalFooter } from '@/src/components/Antd';
import { get } from 'lodash';
import React, { Fragment } from 'react';
import ModalHoc from 'src/constrains/ModalHOC';
import { markDelivered } from 'src/request/order';
//import ClickAndCollectDetail from 'src/pages/Order/AllOrders/OrderDetail/ParcelProcess/Components/ClickAndCollectDetail';
import Shipment from 'src/pages/Order/AllOrders/OrderDetail/ParcelProcess/Components/Shipment';
import { handleOnFormatStoreTimeAndDateWithTimezone } from 'src/tools/tools';
import {
  //packParcel,
  printPackingSlip,
} from 'src/request/order';
import { msg } from 'src/tools/message';
import Category from '../Components/Category';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const ReadyToShip = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    decimalPosition,
    data,
    modalOp,
    orderNo,
    onUpdate,
    onUndo,
    disabled,
    disablePrint,
    taxIncluded,
  } = props;

  const {
    setShowModal,
    setModalTitle,
    setModalContent, //onModalCancel
    setWidth,
  } = modalOp;

  const MarkAsDelivered = (parcelUuid) => {
    markDelivered(parcelUuid).then((res) => {
      onUpdate(res);
      msg.success(
        getI18n('allOrders.orderDetail.delivery_markasdelivered_msgsuccess'),
      );
      setShowModal(false);
    });
  };

  return (
    <Category
      decimalPosition={decimalPosition}
      taxIncluded={taxIncluded}
      onUpdate={onUpdate}
      title={getI18n(`allOrders.orderDetail.readytoship_return_title`)}
      data={data.map((i) => {
        const image = get(i, 'images.0.url');
        const pickedDate = get(i, 'pickedDate', null);
        const packedDate = get(i, 'packedDate', null);
        const pickDate = handleOnFormatStoreTimeAndDateWithTimezone(pickedDate);
        const packDate = handleOnFormatStoreTimeAndDateWithTimezone(packedDate);
        const parcelNo = get(i, 'parcelNo');
        const waybillNo = get(i, 'waybillNo', null);
        const deliveryMethodUuid = get(i, 'deliveryMethodUuid', null);
        const uuid = get(i, 'uuid');
        return {
          uuid,
          image,
          sku: `${orderNo}-${parcelNo}`,
          options: [
            {
              title: getI18n(
                `allOrders.orderDetail.readytoship_returndata_options_pickedtitle`,
              ),
              content: pickDate || '-',
            },
            { title: '', content: '' },
            {
              title: getI18n(
                `allOrders.orderDetail.readytoship_returndata_options_packedtitle`,
              ),
              content: packDate,
            },
          ],
          btns: [
            {
              text: getI18n(
                `allOrders.orderDetail.readytoship_returndata_shipbtns_text`,
              ),
              disabled: disabled,
              onClick: () => {
                setWidth(500);
                setShowModal(true);
                setModalTitle(
                  getI18n(
                    `allOrders.orderDetail.readytoship_returndata_shipbtns_setmodaltitle`,
                  ),
                );
                setModalContent(
                  <Shipment
                    onUpdate={onUpdate}
                    setShowModal={setShowModal}
                    uuid={uuid}
                    deliveryMethodUuid={deliveryMethodUuid}
                    waybillNo={waybillNo}
                  />,
                );
              },
            },
            {
              text: getI18n(
                `allOrders.orderDetail.readytoship_returndata_printbtns_text`,
              ),
              disabled: disablePrint,
              onClick: () => {
                printPackingSlip(uuid);
                // setWidth(980);
                // setShowModal(true);
                // setModalTitle('Click & Collect details');
                // setModalContent(<ClickAndCollectDetail uuid={uuid} />);
              },
            },
          ],
          ...(!disabled && {
            dropOptions: [
              {
                label: getI18n(
                  `allOrders.orderDetail.readytoship_returndata_undodropoptions_label`,
                ),
                onClick: () => {
                  onUndo(uuid, (res) => {
                    onUpdate(res);
                    msg.success(
                      getI18n(
                        `allOrders.orderDetail.readytoship_returndata_undodropoptions_msgsuccess`,
                      ),
                    );
                  });
                },
              },
              {
                label: getI18n(
                  `allOrders.orderDetail.readytoship_returndata_markdropoptions_label`,
                ),
                onClick: () => {
                  setWidth(500);
                  setShowModal(true);
                  setModalTitle(
                    getI18n(
                      `allOrders.orderDetail.readytoship_returndata_markdropoptions_label`,
                    ),
                  );
                  setModalContent(
                    <Fragment>
                      <p className={css.deliveredModal}>
                        {getI18n(
                          `allOrders.orderDetail.readytoship_returndata_markdropoptions_confirmdelivered`,
                        )}
                      </p>
                      <ModalFooter
                        onOk={() => MarkAsDelivered(uuid)}
                        onCancel={() => setShowModal(false)}
                      />
                    </Fragment>,
                  );
                },
              },
            ],
          }),
        };
      })}
    />
  );
};
export default ModalHoc(ReadyToShip, { width: 500 });
